import {isArray, isString} from 'underscore';
import {Observable, tap} from 'rxjs';
import {Validator, ValidatorArgs} from './types';

export const Validators = {
	required: (): Validator<any> => {
		return function (validationChain: Observable<ValidatorArgs<any>>) {
			return validationChain.pipe(tap(args => {
				const value = args.field.currentValue;
				let valid;
				if (isArray(value)) {
					valid = !!value.length;
				} else {
					if (isString(value)) {
						valid = !!value.trim();
					} else {
						valid = !!value;
					}
				}
				if (!valid) {
					args.errors.push('required');
				}
			}));
		};
	},
	range: (from: number, to: number): Validator<number> => {
		return function (validationChain: Observable<ValidatorArgs<number>>) {
			return validationChain.pipe(tap(args => {
				const value = args.field.currentValue;
				const valid = value >= from && value <= to;
				if (!valid) {
					args.errors.push('range');
				}
			}));
		};
	},
	pattern: (regexp: RegExp, errorType: string): Validator<string> => {
		return function (validationChain: Observable<ValidatorArgs<string>>) {
			return validationChain.pipe(tap(args => {
				const value = args.field.currentValue;
				if(value) {
					const valid = !!value && regexp.test(value);
					if (!valid) {
						args.errors.push(errorType);
					}
				}
			}));
		};
	},
	email: (): Validator<string> => {
		const regexp = new RegExp('^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,30}$');
		return Validators.pattern(regexp, 'email');
	},
	length: {
		min: (min: number): Validator<string> => {
			return function (validationChain: Observable<ValidatorArgs<string>>) {
				return validationChain.pipe(tap(args => {
					const value = args.field.currentValue;
					const valid = !!value && value.length >= min;
					if (!valid) {
						args.errors.push('length-min');
					}
				}));
			};
		},
		max: (max: number): Validator<string> => {
			return function (validationChain: Observable<ValidatorArgs<string>>) {
				return validationChain.pipe(tap(args => {
					const value = args.field.currentValue;
					const valid = value.length <= max;
					if (!valid) {
						args.errors.push('length-max');
					}
				}));
			};
		},
	},
	colorHex: (): Validator<string> => {
		return function (validationChain: Observable<ValidatorArgs<string>>) {
			return validationChain.pipe(tap(args => {
				const value = args.field.currentValue;
				if (value === 'none') {
					return;
				}

				const valid = !!value && /^(#[a-fA-F0-9]{6}|[a-fA-F0-9]{6})$/.test(value);
				if (!valid) {
					args.errors.push('hex');
				}
			}));
		};
	},
	phone: (): Validator<string> => {
		return function (validationChain: Observable<ValidatorArgs<string>>) {
			return validationChain.pipe(tap(args => {
				const value = args.field.currentValue;
				const valid = !value || /^[+]?(1-|1\s|1|\d{3}-|\d{3}\s|)?((\(\d{3}\))|\d{3})(-|\s)?(\d{3})(-|\s)?(\d{4}|\d{5})$/.test(value);
				if (!valid) {
					args.errors.push('phone');
				}
			}));
		};
	},
	isDublicateValue: (array: string[]): Validator<string> => {
		return function (validationChain: Observable<ValidatorArgs<string>>) {
			return validationChain.pipe(tap(args => {
				const value = args.field.currentValue;
				if(value) {
					const valid = !array.some(n => n.toLowerCase() === value.toLowerCase());
					if (!valid) {
						args.errors.push('isDublicateValue');
					}
				}
			}));
		};
	},
};
